module.exports = __webpack_public_path__ + "static/img/logo13.957579c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo13.png
// module id = Cs+w
// module chunks = 1